module.exports = __webpack_public_path__ + "img/ico_fail.cd4ab4fa.svg";